{
  "comment": "Reach state rules (M3 plan R5, §2.9 flows 1 and 12). knowledge: the new-game fog. Every system in chartedRegions starts charted; systems within rumourHops online relay hops of a charted system, and the rumouredAnchors, start rumoured. Initial knowledge is recomputed on load (chart novelty compares against it). save: localStorage keys and size limits in UTF-8 bytes (warnBytes logs a warning, maxBytes refuses the save). autosave.everySeconds: the periodic autosave in safe space.",
  "defaultGalaxySeed": 1,
  "knowledge": { "chartedRegions": ["gate"], "rumourHops": 1, "rumouredAnchors": ["megacorp-hq"] },
  "save": {
    "key": "eclipse.reach.save",
    "prevKey": "eclipse.reach.save.prev",
    "corruptKey": "eclipse.reach.save.corrupt",
    "warnBytes": 40960,
    "maxBytes": 51200
  },
  "autosave": { "everySeconds": 120 }
}
